var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgScheduleInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.789 0 3.54 2.308l2.261-.654L6 3.23l-2.062.154 1.354 1.859L3.913 6l-.944-1.962-.832 1.95-1.429-.744 1.342-1.86L0 3.219l.236-1.564 2.211.654L2.2 0h1.59Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgScheduleInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/schedule-info.44c6c917.svg";
export { ForwardRef as ReactComponent };